export default {
  'pages.layouts.userLayout.title': 'News Broadcast',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.template.title': 'Template',
  'pages.template.submit.success': 'Form submitted successfully!',
  'pages.template.form.name': 'Name',
  'pages.template.form.email': 'Email',
  'pages.template.form.department': 'Department',
  'pages.template.form.joinDate': 'Join Date',
  'pages.template.form.remarks': 'Remarks',
  'pages.template.placeholder.name': 'Please enter name',
  'pages.template.placeholder.email': 'Please enter email',
  'pages.template.placeholder.department': 'Please select a department',
  'pages.template.placeholder.remarks': 'Please enter remarks',
  'pages.template.validation.nameRequired': 'Please enter name',
  'pages.template.validation.emailRequired': 'Please enter email',
  'pages.template.validation.emailInvalid': 'Invalid email format',
  'pages.template.validation.departmentRequired': 'Please select a department',
  'pages.template.validation.joinDateRequired': 'Please select a join date',
  'pages.template.department.tech': 'Technology',
  'pages.template.department.sales': 'Sales',
  'pages.template.department.hr': 'Human Resources',
  'pages.template.department.finance': 'Finance',
  'pages.template.action.submit': 'Submit',
  'pages.template.action.reset': 'Reset',
  'pages.newsBroadcast.dashboard.title': 'Overview',
  'pages.newsBroadcast.dashboard.subtitle':
    'News broadcast metrics and quick actions',
  'pages.newsBroadcast.analysis.title': 'Daily Broadcast Judgement',
  'pages.newsBroadcast.analysis.subtitle':
    "Read the policy, industry, and social signals released in today's broadcast",
  'pages.newsBroadcast.analysisTasks.title': 'Analysis Task Center',
  'pages.newsBroadcast.analysisTasks.subtitle':
    'Track status, retry failures, and rebuild snapshots',
  'pages.newsBroadcast.search.title': 'Search',
  'pages.newsBroadcast.search.subtitle': 'Find news with keyword and filters',
  'pages.newsBroadcast.keywordTrends.title': 'Global Keyword Trends',
  'pages.newsBroadcast.keywordTrends.subtitle':
    'Analyze keyword heat, activity, and movement across a time range',
  'pages.newsBroadcast.dailyBrief.title': 'Daily Brief',
  'pages.newsBroadcast.dailyBrief.subtitle':
    'Generate and distribute daily briefs',
  'pages.newsBroadcast.dailyBriefDetail.title': 'Brief Detail',
  'pages.newsBroadcast.dailyBriefDetail.subtitle':
    'Full content, key points, hidden signals and action advice',
  'pages.newsBroadcast.shareBrief.title': 'Daily Broadcast Brief',
  'pages.newsBroadcast.shareBrief.notFound':
    'This brief does not exist or is no longer available',
  'pages.newsBroadcast.shareBrief.keyPoints': 'Key Points',
  'pages.newsBroadcast.shareBrief.hiddenSignals': 'Hidden Signals',
  'pages.newsBroadcast.shareBrief.actionAdvice': 'Action Advice',
  'pages.newsBroadcast.shareBrief.readingTime': '{minutes} min read',
  'pages.newsBroadcast.shareBrief.footer': 'AI-generated content from {brand}',
  'pages.newsBroadcast.dataManagement.title': 'Data Management',
  'pages.newsBroadcast.dataManagement.subtitle':
    'Manage broadcasts and news records',
  'pages.newsBroadcast.admin.title': 'Admin',
  'pages.newsBroadcast.admin.subtitle':
    'Run collection, analysis and maintenance tasks',
  'pages.newsBroadcast.settings.title': 'Settings',
  'pages.newsBroadcast.settings.subtitle':
    'Configure notifications, analysis and data sources',
  'newsBroadcast.dataManagement.broadcastList': 'Broadcast List',
  'newsBroadcast.dataManagement.newsDetail': 'News Detail',
  'newsBroadcast.dataManagement.selectBroadcast': 'Please select a broadcast',
  'newsBroadcast.dataManagement.noNews': 'No news data',
  'newsBroadcast.dataManagement.newsCount': 'News Count',
  'newsBroadcast.dataManagement.lunarDate': 'Lunar Date',
  'newsBroadcast.dataManagement.solarTerm': 'Current Solar Term',
  'newsBroadcast.dataManagement.nextSolarTerm': 'Next Solar Term',
  'newsBroadcast.dataManagement.summary': 'Summary',
  'newsBroadcast.dataManagement.noSummary': 'No summary available',
  'newsBroadcast.dataManagement.readCount': 'Read Count',
  'newsBroadcast.dataManagement.shareCount': 'Share Count',
  'newsBroadcast.dataManagement.heatScore': 'Heat Score',
  'newsBroadcast.dataManagement.keywordAnalysis': 'Keyword Analysis',
  'newsBroadcast.dataManagement.contentAnalysis': 'Content Analysis',
  'newsBroadcast.common.refresh': 'Refresh',
  'newsBroadcast.common.noData': 'No Data',
  'newsBroadcast.common.error': 'Operation failed, please try again later',
  'newsBroadcast.common.published': 'Published',
  'newsBroadcast.common.draft': 'Draft',
  'newsBroadcast.common.archived': 'Archived',
  'newsBroadcast.common.view': 'View',
  'newsBroadcast.common.share': 'Share',
  'newsBroadcast.common.download': 'Download',
  'newsBroadcast.common.keyword': 'Keyword',
};
